import { useContext } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Context } from "../App";

export default function ContainerSelect({containers, container, setContainer}) {
    const [active, setActive] = useState(false);
    const {initialProps} = useContext(Context);
    const [selectedTab, setSelectedTab] = useState("Поэтажные планы");
    
    const toggleMenu = () => {
        setActive(!active)
    }

    const handleTabSelect = (tabName) => {
        setSelectedTab(tabName);
    }

    const handleContainerChange = (event) => {
        const element = event.target;
        const containerName = element.getAttribute("data-container");
    
        if (!containerName) return;
    
        setContainer(containerName);
    }

    useEffect(() => {        
        if (Object.keys(initialProps).length > 0) {
            setTimeout(() => {
                document.querySelector('.room__btn')?.click();
            }, 100)
        }
    }, [initialProps]);

    if (window.offsetWidth > 768) {
        return (
            <div className="room__btn-box" onClick={handleContainerChange}>
                { containers.map(({type, text}, key) => (
                    <button 
                        className={`room__btn ${container === type && "selected"}`} 
                        data-container={type}
                        key={key}
                    >{text}</button>
                ))}
            </div>
        )
    }

    return (
        <>
            <div className="room__filter-select">
                <button className="room__select" onClick={toggleMenu}>
                    {selectedTab}
                </button>
            </div> 
            <div class={`room__btn-box ${active ? "active" : ""}`} onClick={(event) => {
                handleContainerChange(event);
                setActive(!active);
            }}>
                { containers.map(({type, text}, key) => (
                    <button 
                        className={`room__btn ${container === type && "selected"}`} 
                        data-container={type}
                        key={key}
                        onClick={() => handleTabSelect(text)}
                    >{text}</button>
                ))}
            </div>
        </>
    );

}